export const branch = {
  id: 356,
  name: 'Praha - Kolbenova',
  services: {
    buy: true,
    sell: true,
  },
  displaySetting: {
    inBuySelect: true,
    inSellSelect: true,
    inBranchList: true,
    selectName: 'Kolbenova',
  },
  location: {
    street: 'Kolbenova 809/31',
    placeDescription: '',
    city: 'Praha 14 - Hloubětín',
    postalCode: '198 00',
    lat: '50.1094548',
    long: '14.5405419',
    travelInfo: '<p></p>',
  },
  workingHours: {
    selling: {
      mo: {
        open_from: '09:00:00',
        open_to: '19:00:00',
      },
      tu: {
        open_from: '09:00:00',
        open_to: '19:00:00',
      },
      we: {
        open_from: '09:00:00',
        open_to: '19:00:00',
      },
      th: {
        open_from: '09:00:00',
        open_to: '19:00:00',
      },
      fr: {
        open_from: '09:00:00',
        open_to: '19:00:00',
      },
      sa: {
        open_from: '09:00:00',
        open_to: '15:00:00',
      },
      su: {
        open_from: '00:00:00',
        open_to: '00:00:00',
      },
    },
    buying: {
      mo: {
        open_from: '09:00:00',
        open_to: '19:00:00',
      },
      tu: {
        open_from: '09:00:00',
        open_to: '19:00:00',
      },
      we: {
        open_from: '09:00:00',
        open_to: '19:00:00',
      },
      th: {
        open_from: '09:00:00',
        open_to: '19:00:00',
      },
      fr: {
        open_from: '09:00:00',
        open_to: '19:00:00',
      },
      sa: {
        open_from: '09:00:00',
        open_to: '15:00:00',
      },
      su: {
        open_from: '00:00:00',
        open_to: '00:00:00',
      },
    },
    extra: [],
  },
  numberOfCars: 650,
  tag: '',
  tagColor: 3,
  slug: 'kolbenova',
  openningTextBuy: 'Po-Pá 9 - 19, So 9 - 15',
  openningTextSell: 'Po-Pá 9 - 19, So 9 - 15',
};
